import { render, staticRenderFns } from "./TurnaC3.vue?vue&type=template&id=4bd4c69a"
import script from "./TurnaC3.vue?vue&type=script&lang=js"
export * from "./TurnaC3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports